import {
  DEAKIN_FACULTY_FACET_ID,
  DEAKIN_TOPICS_FACET_ID,
  resolveFacultyFacetValue,
  resolveTopicFacetValue,
} from '../../funnelback/deakin-config';
import { getMetadataFieldValue } from '../../utils';

export type PageMetadataFilters = {
  'dxp-topic'?: string;
  'dxp-faculty'?: string;
};

/** Split Matrix semicolon-separated metadata into trimmed tokens. */
export function splitMetadataList(raw: string): string[] {
  if (!raw.trim()) {
    return [];
  }
  return raw
    .split(';')
    .map((part) => part.trim())
    .filter(Boolean);
}

function uniqueNonEmpty(values: string[]): string[] {
  return [...new Set(values.map((v) => v.trim()).filter(Boolean))];
}

/**
 * Convert landing-page metadata strings to `selectedFacets` facet ids + values.
 */
export function parsePageMetadataFacets(
  filters: PageMetadataFilters,
): Record<string, string[]> {
  const selectedFacets: Record<string, string[]> = {};

  const topics = uniqueNonEmpty(
    splitMetadataList(filters['dxp-topic'] ?? '').map(resolveTopicFacetValue),
  );
  if (topics.length > 0) {
    selectedFacets[DEAKIN_TOPICS_FACET_ID] = topics;
  }

  const faculties = uniqueNonEmpty(
    splitMetadataList(filters['dxp-faculty'] ?? '').map(resolveFacultyFacetValue),
  );
  if (faculties.length > 0) {
    selectedFacets[DEAKIN_FACULTY_FACET_ID] = faculties;
  }

  return selectedFacets;
}

/** Read `dxp-topic` / `dxp-faculty` meta tags from the document head. */
export function readPageMetadataFiltersFromDocument(): PageMetadataFilters {
  if (typeof document === 'undefined') {
    return {};
  }
  return {
    'dxp-topic': getMetadataFieldValue('dxp-topic'),
    'dxp-faculty': getMetadataFieldValue('dxp-faculty'),
  };
}
